import BaseProxy from './BaseProxy';

class Auth extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/lesson/statuses', parameters);
    }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/api/LessonStatus.js